import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import {
  TextField,
  Button,
  Checkbox,
  FormControlLabel,
  Grid,
  Paper,
} from "@mui/material";
import { NotificationManager } from "react-notifications";
import CommonLoader from "../../../common/CommonLoader";
import {
  GetTestFormula,
  UpdateTestFormula,
  AddTestFormula,
} from "../../../../services/TestLibService";

const EditTestFormula = () => {
  const { formulaId } = useParams();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    formulaId: "",
    formulaDescription: "",
    input1: "",
    expression1: "",
    input2: "",
    expression2: "",
    input3: "",
    expression3: "",
    input4: "",
    expression4: "",
    input5: "",
    expression5: "",
    input6: "",
    expression6: "",
    input7: "",
    expression7: "",
    input8: "",
    expression8: "",
    input9: "",
    expression9: "",
    input10: "",
    expression10: "",
    textInput1: "",
    textExpression1: "",
    textInput2: "",
    textExpression2: "",
    textInput3: "",
    textExpression3: "",
    analyticalExpression: "",
    command1: "",
    command2: "",
    command3: "",
    command4: "",
    command5: "",
    command6: "",
    command7: "",
    command8: "",
    command9: "",
    command10: "",
    unitsOfPrecision: 0,
    sigfigs: 0,
    textresult: false,
  });

  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    const fetchTestFormula = async () => {
      if (formulaId) {
        setLoading(true);
        try {
          const response = await GetTestFormula(formulaId);
          // Trim all string values before setting to formData
          const trimmedResults = Object.fromEntries(
            Object.entries(response.results).map(([key, value]) => [
              key,
              typeof value === "string" ? (value != null ? value.trim() : "") : value,
            ])
          );
          setFormData(trimmedResults);
        } catch (error) {
          NotificationManager.error("Error fetching test formula data");
        } finally {
          setLoading(false);
        }
      }
    };

    fetchTestFormula();
  }, [formulaId]);

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const handleSubmit = async () => {
    setSaving(true);

    const trimmedFormData = Object.fromEntries(
      Object.entries(formData).map(([key, value]) => [
        key,
        typeof value === "string" ? (value != null ? value.trim() : "") : value,
      ])
    );

    try {
      let response;
      if (formulaId) {
        response = await UpdateTestFormula(trimmedFormData);
      } else {
        response = await AddTestFormula(trimmedFormData);
      }

      if (response.status === 200) {
        NotificationManager.success(
          formulaId ? "Test formula updated successfully" : "Test formula created successfully"
        );
      } else {
        NotificationManager.error(
          formulaId ? "Error updating test formula" : "Error creating test formula"
        );
      }
    } catch {
      NotificationManager.error(
        formulaId ? "Error updating test formula" : "Error creating test formula"
      );
    } finally {
      setSaving(false);
    }
  };

  const handleCancel = () => {
    if (window.opener) {
      window.close();
    } else {
      navigate("/vlp/maintenance-test-formulas");
    }
  };
  return (
    <>
      <CommonLoader loading={loading || saving} />
      <div className="vlp-component-container">
        <span className="title">Test Formula Management</span>
        <hr />

        <Paper style={{ padding: "20px" }}>
          <Grid container spacing={2}>
            {/* Row 1 */}
            <Grid item xs={2}>
              <TextField
                fullWidth
                label="Formula Id"
                name="formulaId"
                value={formData.formulaId}
                onChange={handleInputChange}
                variant="outlined"
                size="small"
                required
                InputProps={{
                  readOnly: formulaId !== undefined,
                }}
              />
            </Grid>
            <Grid item xs={2}>
              <TextField
                fullWidth
                label="Formula Description"
                name="formulaDescription"
                value={formData.formulaDescription}
                onChange={handleInputChange}
                variant="outlined"
                size="small"
                required
              />
            </Grid>
            <Grid item xs={2}>
              <TextField
                fullWidth
                label="Input 1"
                name="input1"
                value={formData.input1}
                onChange={handleInputChange}
                variant="outlined"
                size="small"
              />
            </Grid>
            <Grid item xs={2}>
              <TextField
                fullWidth
                label="Expression 1"
                name="expression1"
                value={formData.expression1}
                onChange={handleInputChange}
                variant="outlined"
                size="small"
              />
            </Grid>

            {/* Row 2 */}
            <Grid item xs={2}>
              <TextField
                fullWidth
                label="Input 2"
                name="input2"
                value={formData.input2}
                onChange={handleInputChange}
                variant="outlined"
                size="small"
              />
            </Grid>
            <Grid item xs={2}>
              <TextField
                fullWidth
                label="Expression 2"
                name="expression2"
                value={formData.expression2}
                onChange={handleInputChange}
                variant="outlined"
                size="small"
              />
            </Grid>
            <Grid item xs={2}>
              <TextField
                fullWidth
                label="Input 3"
                name="input3"
                value={formData.input3}
                onChange={handleInputChange}
                variant="outlined"
                size="small"
              />
            </Grid>
            <Grid item xs={2}>
              <TextField
                fullWidth
                label="Expression 3"
                name="expression3"
                value={formData.expression3}
                onChange={handleInputChange}
                variant="outlined"
                size="small"
              />
            </Grid>

            {/* Row 3 */}
            <Grid item xs={2}>
              <TextField
                fullWidth
                label="Input 4"
                name="input4"
                value={formData.input4}
                onChange={handleInputChange}
                variant="outlined"
                size="small"
              />
            </Grid>
            <Grid item xs={2}>
              <TextField
                fullWidth
                label="Expression 4"
                name="expression4"
                value={formData.expression4}
                onChange={handleInputChange}
                variant="outlined"
                size="small"
              />
            </Grid>
            <Grid item xs={2}>
              <TextField
                fullWidth
                label="Input 5"
                name="input5"
                value={formData.input5}
                onChange={handleInputChange}
                variant="outlined"
                size="small"
              />
            </Grid>
            <Grid item xs={2}>
              <TextField
                fullWidth
                label="Expression 5"
                name="expression5"
                value={formData.expression5}
                onChange={handleInputChange}
                variant="outlined"
                size="small"
              />
            </Grid>

            {/* Row 4 */}
            <Grid item xs={2}>
              <TextField
                fullWidth
                label="Input 6"
                name="input6"
                value={formData.input6}
                onChange={handleInputChange}
                variant="outlined"
                size="small"
              />
            </Grid>
            <Grid item xs={2}>
              <TextField
                fullWidth
                label="Expression 6"
                name="expression6"
                value={formData.expression6}
                onChange={handleInputChange}
                variant="outlined"
                size="small"
              />
            </Grid>
            <Grid item xs={2}>
              <TextField
                fullWidth
                label="Input 7"
                name="input7"
                value={formData.input7}
                onChange={handleInputChange}
                variant="outlined"
                size="small"
              />
            </Grid>
            <Grid item xs={2}>
              <TextField
                fullWidth
                label="Expression 7"
                name="expression7"
                value={formData.expression7}
                onChange={handleInputChange}
                variant="outlined"
                size="small"
              />
            </Grid>

            {/* Row 5 */}
            <Grid item xs={2}>
              <TextField
                fullWidth
                label="Input 8"
                name="input8"
                value={formData.input8}
                onChange={handleInputChange}
                variant="outlined"
                size="small"
              />
            </Grid>
            <Grid item xs={2}>
              <TextField
                fullWidth
                label="Expression 8"
                name="expression8"
                value={formData.expression8}
                onChange={handleInputChange}
                variant="outlined"
                size="small"
              />
            </Grid>
            <Grid item xs={2}>
              <TextField
                fullWidth
                label="Input 9"
                name="input9"
                value={formData.input9}
                onChange={handleInputChange}
                variant="outlined"
                size="small"
              />
            </Grid>
            <Grid item xs={2}>
              <TextField
                fullWidth
                label="Expression 9"
                name="expression9"
                value={formData.expression9}
                onChange={handleInputChange}
                variant="outlined"
                size="small"
              />
            </Grid>

            {/* Row 6 */}
            <Grid item xs={2}>
              <TextField
                fullWidth
                label="Input 10"
                name="input10"
                value={formData.input10}
                onChange={handleInputChange}
                variant="outlined"
                size="small"
              />
            </Grid>
            <Grid item xs={2}>
              <TextField
                fullWidth
                label="Expression 10"
                name="expression10"
                value={formData.expression10}
                onChange={handleInputChange}
                variant="outlined"
                size="small"
              />
            </Grid>
            <Grid item xs={2}>
              <TextField
                fullWidth
                label="Text Input 1"
                name="textInput1"
                value={formData.textInput1}
                onChange={handleInputChange}
                variant="outlined"
                size="small"
              />
            </Grid>
            <Grid item xs={2}>
              <TextField
                fullWidth
                label="Text Expression 1"
                name="textExpression1"
                value={formData.textExpression1}
                onChange={handleInputChange}
                variant="outlined"
                size="small"
              />
            </Grid>

            {/* Row 7 */}
            <Grid item xs={2}>
              <TextField
                fullWidth
                label="Text Input 2"
                name="textInput2"
                value={formData.textInput2}
                onChange={handleInputChange}
                variant="outlined"
                size="small"
              />
            </Grid>
            <Grid item xs={2}>
              <TextField
                fullWidth
                label="Text Expression 2"
                name="textExpression2"
                value={formData.textExpression2}
                onChange={handleInputChange}
                variant="outlined"
                size="small"
              />
            </Grid>
            <Grid item xs={2}>
              <TextField
                fullWidth
                label="Text Input 3"
                name="textInput3"
                value={formData.textInput3}
                onChange={handleInputChange}
                variant="outlined"
                size="small"
              />
            </Grid>
            <Grid item xs={2}>
              <TextField
                fullWidth
                label="Text Expression 3"
                name="textExpression3"
                value={formData.textExpression3}
                onChange={handleInputChange}
                variant="outlined"
                size="small"
              />
            </Grid>

            {/* Row 8 */}
            <Grid item xs={2}>
              <TextField
                fullWidth
                label="Analytical Expression"
                name="analyticalExpression"
                value={formData.analyticalExpression}
                onChange={handleInputChange}
                variant="outlined"
                size="small"
              />
            </Grid>
            <Grid item xs={2}>
              <TextField
                fullWidth
                label="Units of Precision"
                name="unitsOfPrecision"
                value={formData.unitsOfPrecision}
                type="number"
                onChange={handleInputChange}
                variant="outlined"
                size="small"
              />
            </Grid>
            <Grid item xs={2}>
              <TextField
                fullWidth
                label="Sig Figs"
                name="sigfigs"
                type="number"
                value={formData.sigfigs}
                onChange={handleInputChange}
                variant="outlined"
                size="small"
              />
            </Grid>
            <Grid item xs={2}>
              <FormControlLabel
                control={
                  <Checkbox
                    name="textresult"
                    checked={formData.textresult}
                    onChange={handleInputChange}
                  />
                }
                label="Text Result"
              />
            </Grid>

            {/* Row 9 */}
            <Grid item xs={2}>
              <TextField
                fullWidth
                label="Command 1"
                name="command1"
                value={formData.command1}
                onChange={handleInputChange}
                variant="outlined"
                size="small"
              />
            </Grid>
            <Grid item xs={2}>
              <TextField
                fullWidth
                label="Command 2"
                name="command2"
                value={formData.command2}
                onChange={handleInputChange}
                variant="outlined"
                size="small"
              />
            </Grid>
            <Grid item xs={2}>
              <TextField
                fullWidth
                label="Command 3"
                name="command3"
                value={formData.command3}
                onChange={handleInputChange}
                variant="outlined"
                size="small"
              />
            </Grid>
            <Grid item xs={2}>
              <TextField
                fullWidth
                label="Command 4"
                name="command4"
                value={formData.command4}
                onChange={handleInputChange}
                variant="outlined"
                size="small"
              />
            </Grid>

            {/* Row 10 */}
            <Grid item xs={2}>
              <TextField
                fullWidth
                label="Command 5"
                name="command5"
                value={formData.command5}
                onChange={handleInputChange}
                variant="outlined"
                size="small"
              />
            </Grid>
            <Grid item xs={2}>
              <TextField
                fullWidth
                label="Command 6"
                name="command6"
                value={formData.command6}
                onChange={handleInputChange}
                variant="outlined"
                size="small"
              />
            </Grid>
            <Grid item xs={2}>
              <TextField
                fullWidth
                label="Command 7"
                name="command7"
                value={formData.command7}
                onChange={handleInputChange}
                variant="outlined"
                size="small"
              />
            </Grid>
            <Grid item xs={2}>
              <TextField
                fullWidth
                label="Command 8"
                name="command8"
                value={formData.command8}
                onChange={handleInputChange}
                variant="outlined"
                size="small"
              />
            </Grid>

            {/* Row 11 */}
            <Grid item xs={2}>
              <TextField
                fullWidth
                label="Command 9"
                name="command9"
                value={formData.command9}
                onChange={handleInputChange}
                variant="outlined"
                size="small"
              />
            </Grid>
            <Grid item xs={2}>
              <TextField
                fullWidth
                label="Command 10"
                name="command10"
                value={formData.command10}
                onChange={handleInputChange}
                variant="outlined"
                size="small"
              />
            </Grid>
          </Grid>

          <Grid
            container
            justifyContent="flex-end"
            style={{ marginTop: "20px" }}
          >
            <Button
              variant="contained"
              color="primary"
              onClick={handleSubmit}
              disabled={saving || loading}
              style={{ marginRight: "10px" }}
            >
              {saving ? "Saving..." : formulaId ? "Update" : "Save"}
            </Button>
            <Button variant="outlined" onClick={handleCancel} disabled={saving}>
              Cancel
            </Button>
          </Grid>
        </Paper>
      </div>
    </>
  );
};

export default EditTestFormula;
